/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable no-unused-vars */
/* eslint-disable react-native/no-unused-styles */
/* eslint-disable react-native/no-inline-styles */

import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  Svg,
  Path,
} from '@react-pdf/renderer';
import moment from 'moment-timezone';

import { currency, pdfSafeValue } from '@global/helpers';
import { IMAGE_URL } from './constant';
import Footer from './Footer.web';

const PAYMENT_TYPE = {
  tunai: 'Cash',
  giro: 'Giro/Cheque',
  transfer: 'Transfer',
};
const LEGAL_DOCUMENTS_CONFIG = {
  b2b: [
    { label: 'NPWP', key: 'npwp' },
    { label: 'SPPKP', key: 'sppkp' },
    { label: 'NIB', key: 'nib' },
    { label: 'Akta Direksi Perusahaan', key: 'akta_direksi_perusahaan' },
    { label: 'KTP', key: 'ktp' },
    { label: 'Form New Customer', key: 'form_new_customer' },
    { label: 'Kartu Keluarga', key: 'kartu_keluarga' },
    {
      label: 'Surat Ketentuan Perdagangan',
      key: 'surat_ketentuan_perdagangan',
    },
    { label: 'Anggaran Dasar Perusahaan', key: 'anggaran_dasar_perusahan' },
    {
      label: 'Pengesahan Kementrian Hukum dan HAM',
      key: 'pengesahan_kemenhum_ham',
    },
    { label: 'Add Trading Terms', key: 'trading_terms' },
    { label: 'Other File', key: 'other_file' },
  ],
  b2b_vn: [
    { label: 'Enterprise Registration Certificate (ERC)', key: 'erc' },
    { label: 'Power of Attorney (PoA)', key: 'poa' },
    { label: 'Agreement/Trading terms', key: 'form_new_customer' },
    { label: 'Other File', key: 'other_file' },
  ],
};
const PAGE_SIZE = 'LETTER';

export default function PdfCustomer({ data }) {
  const activeFor = data.is_active_for || [];
  const docKeys = activeFor.flatMap(
    (type) => LEGAL_DOCUMENTS_CONFIG[type] || [],
  );
  const attachments = {};
  docKeys.forEach(({ key }) => {
    attachments[key] = data.documents?.some((d) => d.type === key) || false;
  });
  const invoice_schedules = mapInvoiceSchedules(data.invoice_address || []);
  const signatureApprovals = [
    'prepared_by',
    'acknowledge_by',
    'customer_by',
  ].reduce((acc, key) => {
    const sig = data.signatures?.[key];
    acc[key] = {
      name: sig?.name || '',
      image: sig?.url || '',
      type: sig?.type || key,
      created_at: formatCreatedAt(sig?.created_at),
    };
    return acc;
  }, {});
  const isCustomerAgreed = data.signatures?.customer_by?.is_ticked || false;

  function formatCreatedAt(dateString) {
    return dateString
      ? 'Date: ' + moment(dateString).format('DD MMM YYYY')
      : 'Date: ';
  }

  function mapInvoiceSchedules(invoiceAddresses = []) {
    if (!Array.isArray(invoiceAddresses)) {
      return [];
    }

    return invoiceAddresses.map((item) => {
      let dayText = '-';

      if (Array.isArray(item.list_day) && item.list_day.length > 0) {
        try {
          const list = item.list_day
            .map((d) => {
              if (typeof d === 'object' && d !== null && 'list_day' in d) {
                return d.list_day;
              }
              return typeof d === 'string' ? d : '-';
            })
            .filter(Boolean);

          if (list.includes('Anytime')) {
            dayText = 'Anytime';
          } else {
            dayText = list.join(', ');
          }
        } catch (e) {
          console.log('error get invoice schedule list day', e);
        }
      }

      return {
        day: dayText,
        time:
          item.from_time && item.to_time
            ? `${item.from_time} - ${item.to_time}`
            : '-',
        address: [
          item.street,
          item.street2,
          item.city?.name,
          item.state?.name,
          item.country?.name,
          item.postal_code,
        ]
          .filter(Boolean)
          .join(', '),
        supporting_doc: '-',
      };
    });
  }

  const Row = ({ label, value }) => (
    <View style={styles.row}>
      <Text style={styles.label}>{label}</Text>
      <Text style={styles.colon}>:</Text>
      <Text style={styles.value}>{pdfSafeValue(value)}</Text>
    </View>
  );

  const Check = ({ size = 10, color = '#000' }) => (
    <Svg width={size} height={size} viewBox="0 0 24 24">
      <Path
        d="M20 6L9 17l-5-5"
        stroke={color}
        strokeWidth={3}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );

  return (
    <Document>
      {/* Page 1 */}
      <Page size={PAGE_SIZE} style={styles.page} wrap>
        <View style={styles.headerRow}>
          <View style={{ width: 90, alignItems: 'flex-start' }}>
            <Image
              src={IMAGE_URL}
              style={{ width: 90, height: 48, objectFit: 'contain' }}
            />
          </View>
          <Text style={styles.headerTitle}>CUSTOMER REGISTRATION FORM</Text>
          <View style={{ width: 90 }} />
        </View>
        <View style={styles.headerLine} />

        <View style={styles.twoCol}>
          <View style={styles.leftCol}>
            <Text style={styles.sectionTitle}>DETAIL</Text>
            <View style={styles.table3}>
              <Row label="Customer ID" value={data.customer_code || ''} />
              <Row label="Customer Name" value={data.name} />
              <Row label="Person in Charge (PIC)" value={data.owner_name} />
              <Row label="Job Title" value={data.job_position} />
              <Row label="Phone" value={data.phone} />
              <Row label="Mobile" value={data.mobile} />
              <Row label="Email" value={data.email} />
              <Row label="Street" value={data.street} />
              <Row label="Country" value={data.country?.name} />
              <Row label="State" value={data.state?.name} />
              <Row label="City" value={data.city?.name} />
              <Row label="ZIP Code" value={data.postal_code} />
              <Row
                label="Identification Number"
                value={data.ktp_address?.identification_number || data.ktp}
              />
              <Row
                label="Tax Identification Number"
                value={data.vat_address?.identification_number || data.vat}
              />
              <Row label="Payment Terms" value={data.payment_terms?.name} />
              <Row
                label="Payment Type"
                value={PAYMENT_TYPE[data.payment_type]}
              />
              <Row
                label="Limit Amount"
                value={
                  data.limit_amount ? currency(data.limit_amount, true) : '-'
                }
              />
              <Row label="Discount Regular" value={data.cluster?.name} />
              <Row
                label="Business Type"
                value={data.market_type?.business_type?.code}
              />
              <Row label="Purchase Type" value="Direct Purchase" />
            </View>
          </View>

          <View style={styles.rightCol}>
            <Text style={styles.sectionTitle}>Attachment</Text>
            <View style={styles.attachmentList}>
              {(docKeys || []).map((doc, idx) => (
                <View key={idx} style={styles.checkboxRow}>
                  <View style={styles.checkbox}>
                    {attachments?.[doc.key] ? <Check /> : false}
                  </View>
                  <Text>{doc.label}</Text>
                </View>
              ))}
            </View>
          </View>
        </View>

        <Text style={styles.sectionTitle}>
          PROMOTION CLAIM PROCEDURE (Transfer)
        </Text>
        <View style={styles.table3}>
          <Row label="Bank Name" value={data.bank_account?.name} />
          <Row label="Branch" value={data.bank_account?.branch} />
          <Row
            label="Account Number"
            value={data.bank_account?.account_number}
          />
          <Row label="Account Name" value={data.bank_account?.owner_name} />
        </View>

        <Text style={styles.sectionTitle}>INVOICING SCHEDULE</Text>
        {(invoice_schedules || []).map((inv, idx) => (
          <View key={idx} style={styles.table3}>
            <Row label="Day" value={inv.day} />
            <Row label="Time" value={inv.time} />
            <Row label="Address" value={inv.address} />
          </View>
        ))}

        <View style={styles.signature}>
          <View style={styles.signatureTable}>
            <View style={styles.signatureCell}>
              <Text style={styles.signatureLabel}>Prepared by</Text>
              <View style={styles.signatureBox}>
                {signatureApprovals?.prepared_by?.image ? (
                  <Image
                    src={signatureApprovals.prepared_by.image}
                    style={styles.signatureImg}
                  />
                ) : null}
              </View>
              <View style={styles.signatureMeta}>
                <Text style={styles.signatureName}>
                  {signatureApprovals?.prepared_by?.name || ' '}
                </Text>
                {signatureApprovals?.prepared_by?.created_at ? (
                  <Text style={styles.signatureDate}>
                    {signatureApprovals.prepared_by.created_at}
                  </Text>
                ) : null}
              </View>
            </View>

            <View style={styles.signatureCell}>
              <Text style={styles.signatureLabel}>Acknowledged by</Text>
              <View style={styles.signatureBox}>
                {signatureApprovals?.acknowledge_by?.image ? (
                  <Image
                    src={signatureApprovals.acknowledge_by.image}
                    style={styles.signatureImg}
                  />
                ) : null}
              </View>
              <View style={styles.signatureMeta}>
                <Text style={styles.signatureName}>
                  {signatureApprovals?.acknowledge_by?.name || ' '}
                </Text>
                {signatureApprovals?.acknowledge_by?.created_at ? (
                  <Text style={styles.signatureDate}>
                    {signatureApprovals.acknowledge_by.created_at}
                  </Text>
                ) : null}
              </View>
            </View>

            <View style={styles.signatureCell}>
              <Text style={styles.signatureLabel}>Customer</Text>
              <View style={styles.signatureBoxCustomer}>
                <View style={styles.checkText}>
                  <View
                    style={
                      isCustomerAgreed
                        ? styles.checkboxBlue
                        : styles.checkboxGray
                    }>
                    {isCustomerAgreed ? <Check color="white" /> : false}
                  </View>
                  <Text style={styles.agreementText}>
                    I have read, understood, provided correct information, and
                    agree with the customer registration form and its
                    attachments.
                  </Text>
                </View>
                {signatureApprovals?.customer_by?.image ? (
                  <View style={styles.signatureImageContainer}>
                    <Image
                      src={signatureApprovals.customer_by.image}
                      style={styles.signatureImg}
                    />
                  </View>
                ) : null}
                <View style={styles.meteraiWrap}>
                  <View style={styles.meteraiBox}>
                    <Text style={styles.meteraiText}>materai Rp 10.000,-</Text>
                  </View>
                </View>
              </View>
              <View style={styles.signatureMeta}>
                <Text style={styles.signatureName}>
                  {signatureApprovals?.customer_by?.name || ' '}
                </Text>
                {signatureApprovals?.customer_by?.created_at ? (
                  <Text style={styles.signatureDate}>
                    {signatureApprovals.customer_by.created_at}
                  </Text>
                ) : null}
              </View>
            </View>
          </View>

          <Text style={styles.promoNote}>
            *Return terms: Maximum 1% of total sell in current year (excluding
            VAT & excluding discounts), unless there is a request to return
            goods from the brand owner
          </Text>
        </View>
        <Footer />
      </Page>

      {/* Page 2: Lampiran */}
      <Page size={PAGE_SIZE} style={styles.page} wrap>
        <View style={styles.lampiranSection}>
          <Text style={styles.lampiranTitle}>
            LAMPIRAN I FORM PENGAJUAN TOKO BARU
          </Text>
          <Text
            style={{
              textAlign: 'justify',
              marginBottom: 8,
              fontSize: 7,
              lineHeight: 1.5,
            }}>
            Pengecer dan PT Semesta Distribusi Indonesia (“SDI”) dengan ini
            setuju untuk mengikatkan diri berdasarkan Form Pengajuan Toko Baru
            dan lampiran-lampirannya (“Kerjasama”) dengan ketentuan lebih lanjut
            sebagai berikut:
          </Text>
          <View style={styles.ol}>
            {defaultLampiranItems.map((text, idx) => (
              <View key={idx} style={styles.li}>
                <Text style={styles.liNumber}>{`${idx + 1}.`}</Text>
                <Text style={styles.liText}>{text}</Text>
              </View>
            ))}
          </View>
        </View>

        <Footer />
      </Page>
    </Document>
  );
}

const styles = StyleSheet.create({
  page: {
    paddingTop: 10,
    paddingBottom: 40,
    paddingHorizontal: 25,
    fontSize: 10,
    color: '#000',
    fontFamily: 'Roboto',
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerTitle: {
    fontSize: 12,
    fontWeight: 700,
    color: '#0C1544',
    textAlign: 'center',
    flex: 1,
    marginHorizontal: 10,
  },
  headerLine: {
    marginTop: 1,
    height: 1,
    backgroundColor: '#000',
    width: '100%',
  },
  sectionTitle: {
    fontWeight: 'bold',
    fontSize: 10,
    marginTop: 10,
    marginBottom: 10,
    textDecoration: 'underline',
  },
  twoCol: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: 8,
  },
  leftCol: { width: '65%' },
  rightCol: { width: '30%' },
  table3: { width: '100%', fontSize: 8 },
  row: { flexDirection: 'row', marginBottom: 3 },
  label: { color: '#636A78', width: 120, marginRight: 4 },
  colon: { width: 10 },
  value: { flexGrow: 1, color: '#000', width: '100%' },
  attachmentList: { flexDirection: 'column' },
  checkboxRow: { flexDirection: 'row', alignItems: 'center', marginBottom: 6 },
  checkbox: {
    width: 12,
    height: 12,
    borderWidth: 1,
    borderColor: '#999',
    textAlign: 'center',
    fontSize: 10,
    fontWeight: 'bold',
    marginRight: 6,
  },
  promoNote: {
    fontSize: 7,
    marginTop: 5,
    color: '#666',
    marginLeft: 5,
    fontStyle: 'italic',
  },
  signature: { marginTop: 15 },
  signatureTable: { width: '100%', flexDirection: 'row' },
  signatureCell: { width: '33.33%', padding: 5 },
  signatureLabel: { fontSize: 8, color: '#666', marginBottom: 8 },
  signatureBox: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 6,
    minHeight: 120,
    padding: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  signatureBoxCustomer: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 6,
    padding: 10,
    minHeight: 120,
    justifyContent: 'space-between',
  },
  signatureImg: { width: 100, height: 60 },
  signatureImageContainer: {
    width: '100%',
    alignItems: 'center',
    marginTop: 8,
  },
  signatureMeta: { minHeight: 36, justifyContent: 'flex-start', marginTop: 3 },
  signatureName: {
    fontSize: 8,
    color: '#0070f3',
    marginTop: 4,
    textAlign: 'left',
  },
  signatureDate: {
    fontSize: 8,
    color: '#666',
    marginTop: 4,
    textAlign: 'left',
  },
  checkText: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: '100%',
  },
  agreementText: {
    fontSize: 6,
    lineHeight: 1.4,
    flex: 1,
    flexWrap: 'wrap',
  },
  checkboxBlue: {
    width: 12,
    height: 12,
    borderWidth: 1,
    borderColor: '#0070f3',
    backgroundColor: '#0070f3',
    color: '#fff',
    textAlign: 'center',
    fontSize: 8,
    lineHeight: 12,
    marginRight: 6,
  },
  checkboxGray: {
    width: 12,
    height: 12,
    borderWidth: 1,
    borderColor: '#999',
    color: '#fff',
    textAlign: 'center',
    fontSize: 8,
    lineHeight: 12,
    marginRight: 6,
  },
  lampiranSection: {
    color: '#000',
    marginTop: 20,
  },
  lampiranTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 16,
    textTransform: 'uppercase',
  },
  ol: { marginLeft: 12 },
  li: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  liNumber: {
    fontSize: 7,
    lineHeight: 1.5,
    width: 15,
    flexShrink: 0,
  },
  liText: {
    textAlign: 'justify',
    fontSize: 7,
    lineHeight: 1.5,
    flex: 1,
  },
  meteraiWrap: {
    width: '100%',
    alignItems: 'center',
  },
  meteraiBox: {
    width: 80,
    height: 60,
    borderWidth: 1,
    borderColor: '#C2C2C2',
    borderStyle: 'dashed', // test dulu solid
    alignItems: 'center',
    justifyContent: 'center',
  },
  meteraiText: {
    color: '#C2C2C2',
    fontSize: 8,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});

const defaultLampiranItems = [
  'SDI dari waktu ke waktu berhak untuk menetapkan harga atas barang-barang yang dipasok olehnya kepada Pengecer berdasarkan Kerjasama ini (“Barang”). Pengecer hanya dapat menjual Barang ke konsumen akhir dan tidak melakukan distribusi Barang di luar daripada areanya. Pengecer hanya dapat menguasai dan menjual Barang sepanjang Kerjasama ini berlaku dan tanpa adanya permintaan dari instansi berwenang, prinsipal dan/atau SDI (yang disebabkan karena pelanggaran Pengecer) untuk menghentikan penjualan atau distribusi.',
  'Pengecer wajib melakukan pembayaran atas setiap pembelian Barang kepada SDI secara penuh dan tepat waktu. Pembayaran yang sah adalah pembayaran melalui transfer ke rekening atas nama SDI yang disampaikan SDI secara terpisah (untuk pembayaran transfer dan Giro) atau apabila pembayaran dilakukan secara tunai, pembayaran yang atasnya telah diberikan invoice asli dan resmi dari SDI kepada Pengecer. Apabila karena satu dan lain hal, pembayaran belum secara penuh diterima oleh SDI hingga melewati Jangka Waktu Bayar sebagaimana tercantum di Form Pengajuan Toko Baru, maka: (i) Pengecer dengan ini memberikan kuasa kepada SDI untuk melakukan pemotongan tagihan dari Pengecer kepada SDI dalam hal SDI memiliki tunggakan atau kewajiban pembayaran kepada Pengecer; dan/atau (ii) sepanjang SDI hendak atau bersedia menerima retur atas Barang yang masih berada dalam penguasaan Pengecer namun dalam kondisi baru serta layak dijual kembali, maka Pengecer dengan ini memberikan segala kuasa yang diperlukan (jika ada) bagi SDI untuk melakukan penarikan kembali atas Barang retur dari lokasi penyimpanan Pengecer atas biaya Pengecer dan karenanya nilai retur yang dapat diterima SDI tersebut akan diperhitungkan kembali secara proporsional untuk mengurangi sisa pembayaran (utang) yang belum dilunasi oleh Pengecer.',
  'Pengecer wajib menandatangani berita acara penerimaan (sebagaimana relevan) Barang atas setiap Barang yang diterimanya secara sesuai. Pengecer wajib mengikuti seluruh standar operasional prosedur (“SOP”) yang berlaku di SDI seperti tetapi tidak terbatas pada pemesanan, pengiriman, pembayaran, promosi serta retur/pengembalian Barang dari Pengecer kepada SDI. Dalam hal SDI menggunakan sistem elektronik untuk pelaksanaan SOP maka Pengecer dengan ini akan menyetujui kebijakan privasi serta syarat dan ketentuan yang berlaku dari sistem elektronik tersebut.',
  'Atas permintaan SDI dengan cara dan bentuk apapun, Pengecer wajib untuk memberikan kepada SDI data penjualan Barang serta dokumen-dokumen legalitas lainnya yang dipandang perlu oleh SDI.',
  'Pengecer wajib menjaga kerahasiaan atas seluruh informasi diketahuinya termasuk akses atas layanan sistem elektronik yang disediakan SDI (jika ada) sehubungan dengan pelaksanaan Kerjasama ini, meskipun Kerjasama telah berakhir.',
  'Pengecer dengan ini menyatakan bahwa dirinya memiliki segala legalitas, perizinan, sertifikasi dan persetujuan dalam bentuk dan nama apapun berdasarkan hukum, untuk melaksanakan Kerjasama ini termasuk tetapi tidak terbatas dalam melakukan penjualan atas Barang.',
  'Kecuali disetujui secara tertulis oleh SDI atau berdasarkan permintaan SDI yang disetujui Pengecer, (i). Pengecer dilarang untuk mendapatkan pasokan Barang dari pihak lain selain SDI; dan (ii) menggunakan hak kekayaan intelektual SDI dan/atau Barang demi kepentingan apapun, baik secara langsung ataupun tidak langsung. Pengecer juga dilarang menggunakan hak kekayaan intelektual milik pihak lain terkait Barang, dan Pengecer atas permintaan SDI wajib menghentikan (termasuk menghapus) segala publikasi yang telah dilakukannya terhadap Barang.',
  'Kerjasama ini berlaku secara terus menerus kecuali dalam hal salah satu pihak mengakhiri Kerjasama dengan pemberitahuan 30 (tiga puluh) hari sebelumnya. Mengesampingkan ketentuan sebelumnya, SDI tanpa suatu kompensasi apapun dapat mengakhiri kerjasama ini secara seketika dalam hal Pengecer melanggar satu atau ketentuan Kerjasama ini (termasuk pelanggaran dalam melakukan kewajiban pembayarannya), SDI memutuskan untuk menghentikan peredaran Barang pada wilayah Pengecer, SDI kehilangan haknya untuk mengedarkan atau memasok Barang dan/atau terdapat perintah dari otoritas berwenang untuk prinsipal Barang untuk menghentikan peredaran Barang. SDI dari waktu ke waktu dapat mengubah seluruh ketentuan dalam Kerjasama ini, dan dalam hal Pengecer tidak menyetujui perubahan tersebut maka baik Pengecer ataupun SDI dapat mengakhiri Kerjasama ini.',
  'Setiap pengakhiran atas Kerjasama ini: a) tidak serta merta mengakhiri setiap kewajiban masing-masing pihak kepada pihak lainnya yang telah timbul sebelum berakhirnya Kerjasama ini; dan b) mengesampingkan Pasal 1226 KUHPerdata. Dalam hal terjadi pengakhiran tanpa ada pelanggaran dari Pengecer dan terdapat sisa Barang belum terjual dalam kondisi baik dan layak jual berdasarkan inspeksi sisa stok Barang oleh SDI, maka SDI atas kewenangannya dengan atau tanpa mengesampingkan ketentuan relevan dalam Kesepakatan ini, dapat melakukan pembelian Barang sisa tersebut dengan harga pembelian setara dengan harga jual Barang dari SDI kepada Pengecer dikurangi biaya pengiriman Barang sisa tersebut ke gudang SDI.',
  'SDI dan Pengecer sepakat bahwa ketentuan Force Majeure dalam hukum dapat berlaku dalam Kesepakatan ini apabila keadaan Force Majeure merupakan penyebab langsung atas tidak dapat dilaksanakan kewajiban, tidak dapat diduga dan di luar kendali dari SDI atau Pengecer (sebagaimana relevan).',
  'Dalam hal timbul perselisihan di antara para pihak atas Kerjasama, dan tidak tercapai musyawarah dalam jangka waktu 30 hari, maka perselisihan akan diselesaikan melalui Badan Arbitrase Nasional Indonesia (“BANI”) di Jakarta sesuai peraturan BANI yang berlaku.',
  'Kerjasama ini bersifat menyeluruh antara para pihak dan tidak ada perjanjian atau persyaratan dalam bentuk apa pun antara Para Pihak, dalam bentuk lisan maupun tulisan selain dari Kesepakatan. Dalam hal terdapat perubahan, perubahan tersebut hanya berlaku apabila dilakukan secara tertulis, konfirmasi e-mail, atau adanya coretan yang kemudian di-paraf oleh SDI dan Pengecer.',
  'Apabila salah satu isi dari Kesepakatan ini menjadi tidak berlaku karena suatu hukum, maka isi Kesepakatan yang lain akan tetap berlaku sehingga SDI Dalam hal salah satu pihak melanggar ketentuan Kerjasama ini dan pihak lain tidak memberikan teguran atas pelanggaran tersebut, maka dengan tidak diberikannya teguran tidak dapat diartikan sebagai suatu persetujuan atau izin atas pelanggaran tersebut.',
  'Pengecer menjamin bahwa dirinya tidak melakukan penawaran, berjanji tidak akan menawarkan, membujuk, berjanji untuk memberi atau membayar, atau mengesahkan pembayaran uang apa pun termasuk tetapi tidak terbatas pada setiap personel atau utusan SDI baik secara langsung atau tidak langsung, untuk tujuan: (i) mempengaruhi tindakan atau keputusan SDI; (ii) mendapatkan keuntungan yang tidak patut dari SDI; (iii) melakukan praktek kolusi maupun nepotisme dengan pihak manapun dari SDI; (iv) melakukan atau mengabaikan tindakan yang melanggar kewajibannya yang sah menurut hukum dan/atau peraturan perundang-undangan yang berlaku.',
];
